import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import config from '@/config';
const { API_URL } = config;

export const fetchProduct = createAsyncThunk('product/fetch', async (id) => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/product?id=${id}`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return {};
  }
});

const productSlice = createSlice({
  name: 'product',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProduct.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProduct.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          state.status = 'succeeded';
          state.data = action.payload?.data;
          state.error = null;
        } else {
          state.status = 'failed';
          state.error = action.payload.message;
        }
      })
      .addCase(fetchProduct.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default productSlice.reducer;
